export default "__VITE_ASSET__zNmpRU21__"